import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import {
  DashboardService,
  AdminDashboardStats,
} from "@/services/DashboardService";
import { formatPublicReference } from "@/utils/formatReference";
import { inquiryStatusLabel } from "@/utils/statusLabels";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminHomeView',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
const dashboardService = new DashboardService();

const stats = ref<AdminDashboardStats | null>(null);
const loading = ref(true);
const error = ref(false);

const newInquiriesCount = computed(() => stats.value?.newInquiriesCount ?? 0);
const offersSentCount = computed(() => stats.value?.offersSentCount ?? 0);
const acceptedOffersCount = computed(
  () => stats.value?.acceptedOffersCount ?? 0
);
const activeBookingsCount = computed(
  () => stats.value?.activeBookingsCount ?? 0
);
const overdueBillsCount = computed(() => stats.value?.overdueBillsCount ?? 0);
const latestInquiries = computed(() => stats.value?.latestInquiries ?? []);
const upcomingCheckIns = computed(() => stats.value?.upcomingCheckIns ?? []);

const statusColor = (status: string): string => {
  const colors: Record<string, string> = {
    NEW: "warning",
    "OFFER SENT": "info",
    "OFFER ACCEPTED": "primary",
    BOOKED: "success",
    CANCELLED: "error",
  };
  return colors[status] ?? "grey";
};

const fetchDashboardData = async () => {
  loading.value = true;
  error.value = false;
  try {
    stats.value = await dashboardService.getAdminStats();
  } catch (e) {
    console.error("Failed to load admin dashboard data", e);
    error.value = true;
  } finally {
    loading.value = false;
  }
};

const navigateToInquiries = (status?: string) => {
  router.push({
    path: "/admin/accommodationinquiries",
    query: status ? { status } : {},
  });
};

const navigateToBookings = () => {
  router.push({ path: "/admin/bookings", query: { status: "BOOKED" } });
};

const navigateToBills = () => {
  router.push("/admin/bills");
};

const navigateToInquiryDetails = (id: number) => {
  router.push(`/admin/inquiry/details/${id}`);
};

const navigateToBookingDetails = (publicReference: string) => {
  router.push(`/admin/bookings/${publicReference}`);
};

fetchDashboardData();

const __returned__ = { router, dashboardService, stats, loading, error, newInquiriesCount, offersSentCount, acceptedOffersCount, activeBookingsCount, overdueBillsCount, latestInquiries, upcomingCheckIns, statusColor, fetchDashboardData, navigateToInquiries, navigateToBookings, navigateToBills, navigateToInquiryDetails, navigateToBookingDetails, ref, computed, get useRouter() { return useRouter }, get DashboardService() { return DashboardService }, get AdminDashboardStats() { return AdminDashboardStats }, get formatPublicReference() { return formatPublicReference }, get inquiryStatusLabel() { return inquiryStatusLabel } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})